/**
 * Decorative sparkle marking AI-generated content.
 *
 * `aria-hidden` + `focusable="false"` per W3C WAI — the parent supplies the accessible label,
 * so announcing this too would just be noise for a screen reader.
 */
export default function SparkleIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M8 0l1.6 4.6L14 6.4l-4.4 1.8L8 12.8 6.4 8.2 2 6.4l4.4-1.8L8 0z" />
      <path d="M13 10l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7.7-2z" />
    </svg>
  );
}
